<template>
      <div no-body class="lku-adv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="9">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=1 label="Filter">
              <b-row>
                <b-col class="pr-1" cols="3"><b-form-input v-model="tblData.assetCatgName" :disabled="((tblData.assetCatgId ||'') !=='')" @keyup.13.native="refresh()" size="sm" placeholder="Asset Category"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="4"><b-form-input v-model="tblData.assetModel" @keyup.13.native="refresh()" size="sm" placeholder="Model/Type"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="5"><b-form-input v-model="tblData.inspectName" @keyup.13.native="refresh()" size="sm" placeholder="Description" ></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=3 >
              <b-row>
                <b-button class="btn btn-success mr-1" @click="refresh()" size="sm"> <i class="fa fa-search"></i> Search</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear</b-button>
              </b-row>
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblPr"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
          show-empty
        >
          <template v-slot:cell(costEstimate)="data">
          <span v-if="(data.item.costEstimate)">{{data.item.matauang}} &nbsp;{{data.item.costEstimate|numFormat}}</span>
          </template>
        <template v-slot:cell(intervalCal)="data">
          {{data.item.intervalCal | numFormat}} DAYS <br>
          <p v-if="(data.item.intervalUom)">{{data.item.intervalUom |numFormat }} {{data.item.intervalUomCode}}</p>
        </template>

          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>
<style lang="scss">
  .lku-adv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import mm from "../../apis/maintenguide";
export default {
  data() {
    return {
      items:[],
      fields: [
          {
            key: "assetCatgName",
            label: "Category/Group Assets",
            sortable: true
          },
          {
            key: "assetModel",
            label: "Model/Type",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "assetPart",
            label: "Part",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "referDoc",
            label: "Doc. No.",
            sortable: true
          },
          {
            key: "inspectName",
            label: "Maintenance/Inspection Name",
            sortable: true
          },
          {
            key: "intervalCal",
            label: "Repetitif Interval",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'inspectName',
        sortDesc: false,
      },
      lkuLoading:false
    };
  },
  props:["assetCatgId","assetCatgName"],
  computed: {
    catgId() {
      return this.tblData.assetCatgId;
    },
    catgName() {
      return this.tblData.assetCatgName;
    },
  },
  watch: {
    catgId: function(newval) {
      this.$emit('update:assetCatgId', newval);
    },    
    catgName: function(newval) {
      this.$emit('update:assetCatgName', newval);
    },    
  },
  created: function() {
      this.tblData.assetCatgId=this.assetCatgId || '';
      this.tblData.assetCatgName=this.assetCatgName || '';
      // console.log('beforeCreated',this.tblData)
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // console.log('this.tblData',this.tblData)
      this.lkuLoading=true;
      const list = await mm.list(this.tblData);          
      this.lkuLoading=false;
      return list;
    },

    selectItem(item,index) {
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.inspectName=  '';
        this.tblData.assetCatgName=  '';
        this.tblData.assetModel=  '';
        this.tblData.assetCatgId='';
        this.refresh();
    },    
    refresh: async function() {
      this.$refs.tblPr.refresh();
    }
  }
};
</script>
